
import { defineComponent } from "vue";
import InformationIcon from "@/ui-library/icons/information-icon.vue";
import ReportIssueButton from "../../report-issue/components/report-issue-button.vue";

export default defineComponent({
  components: { ReportIssueButton, InformationIcon },
});
